module.exports = __webpack_public_path__ + "img/Group 4640.eb420a61.png";